<template>
  <div :class="selector"
       class="message-modal  modal__content-inner">
    <div class="modal__head">
      <h3 class="modal__title" v-html="computedTitle" data-html/>
      <button @click.prevent="$vModal.close('message')"
              class="modal__close">
        <i class="mpc-icon-part mpc-hover mpc-transition  eti eti_close"></i>
      </button>
    </div>
    <div class="modal__main">
      <div class="message-modal__text" v-if="message">
        {{stripHtml(message)}}
      </div>
      <div class="message-modal__footer">
        <button @click.prevent="onOk"
                class="message-modal__btn  base-btn">{{buttonText || 'Ok'}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {SUCCESS, WARNING, ERROR} from '@/constants/messagesTypes'
  import stripHtml from '@/helpers/stripHtml'

  export default {
    props: {
      title: {
        type: String
      },
      message: {
        type: String
      },
      type: {
        type: String
      },
      buttonText: {
        type: String
      },
      callBack: {
        type: Function
      }
    },
    data() {
      return {
        stripHtml
      }
    },
    computed: {
      selector() {
        return {
          '_success': this.type === SUCCESS,
          '_warning': this.type === WARNING,
          '_error': this.type === ERROR,
        }
      },
      computedTitle() {
        return this.title || '&nbsp;'
      }
    },
    methods: {
      onOk() {
        this.$vModal.close('message')
        if(typeof this.callBack === 'function') {
          this.callBack()
        }
      }
    }
  }
</script>

<style lang="less">

</style>
